import React from 'react';
import * as THREE from 'three';

export interface ILight {
  ref?: any;
  type: string;
  id?: string;
  color?: number;
  intensity: number;
  position?: THREE.Vector3;
  distance?: number;
  decay?: number;
  angle?: number;
  penumbra?: number;
  visible?: Boolean;
  shadow?: Boolean;
  skyColor?: number;
  groundColor?: number;
  shadowMapWidth?: number;
  shadowMapHeight?: number;
  shadowBias?: number;
  shadowCameraNear?: number;
  shadowCameraFar?: number;
  shadowCameraLeft?: number;
  shadowCameraRight?: number;
  shadowCameraTop?: number;
  shadowCameraBottom?: number;
}

export enum LIGHT_TYPE {
  AMBIENT = 'ambient',
  DIRECTIONAL = 'directional',
  SPOTLIGHT = 'spot',
  POINTLIGHT = 'point',
  HEMISPHERELIGHT = 'hemisphere',
}

export interface ILightTemplateComponent {
  templateIndex: number;
  lightsIn: Array<any>;
  isEnableShadowLight;
}

const directionalCSM = {
  type: 'directional', //directiontal csm
  position: new THREE.Vector3(225.96, 179.6, 137.28),
  color: 0xffffff,
  intensity: 1,
};

export function LightTemplateComponent({
  templateIndex,
  lightsIn = [],
  isEnableShadowLight,
}: ILightTemplateComponent) {
  const [lightsSelected, setLightsSelected] = React.useState<Array<ILight>>([
    ...lightsIn[templateIndex || 0].lights,
    ...(isEnableShadowLight ? [] : []),
  ]);

  React.useEffect(() => {
    setLightsSelected([
      ...lightsIn[templateIndex || 0].lights,
      ...(isEnableShadowLight ? [] : []),
    ]);
  }, [templateIndex, isEnableShadowLight]);

  return (
    <>
      {lightsSelected.map((light: ILight, index: number) => {
        switch (light.type) {
          case LIGHT_TYPE.AMBIENT:
            return (
              <ambientLight
                color={light.color ? light.color : 0xffffff}
                intensity={light.intensity ? light.intensity : 1}
                key={`light-${index}`}
              />
            );

          case LIGHT_TYPE.DIRECTIONAL:
            return (
              <directionalLight
                color={light.color ? light.color : 0xffffff}
                intensity={light.intensity ? light.intensity : 2.5}
                position={light.position ? light.position : [0, 0, 0]}
                key={`light-${index}`}
              />
            );
          case LIGHT_TYPE.HEMISPHERELIGHT:
            return (
              <hemisphereLight
                color={light.color ? light.color : 0xffffff}
                intensity={light.intensity ? light.intensity : 1}
                key={`light-${index}`}
              />
            );
          case LIGHT_TYPE.POINTLIGHT:
            return (
              <pointLight
                color={light.color ? light.color : 0xffffff}
                intensity={light.intensity ? light.intensity : 1.5}
                position={light.position ? light.position : [0, 0, 0]}
                decay={light.decay ? light.decay : 0.0}
                distance={light.distance ? light.distance : 50}
                key={`light-${index}`}
              />
            );
          case LIGHT_TYPE.SPOTLIGHT:
            return (
              <spotLight
                color={light.color ? light.color : 0xffffff}
                intensity={light.intensity ? light.intensity : 2}
                position={light.position ? light.position : [0, 0, 0]}
                decay={light.decay ? light.decay : 0}
                distance={light.distance ? light.distance : 0}
                angle={light.angle ? light.angle : 0.5}
                penumbra={light.penumbra ? light.penumbra : 0.5}
                key={`light-${index}`}
              />
            );
          default:
            return <></>;
        }
      })}
    </>
  );
}
